<template>
  <v-app id="inspire">
    
    <v-content >
      
      <v-container
        class="fill-height"
        fluid
      >
       
        <v-row
          align="center"
          justify="center"
        >
       
          <v-col
            cols="12"
            sm="6"
            md="4"
          >

            <v-row 
              justify="center"
              class="pb-5"
            >
       
              <FundacionLogo />

            </v-row>

            <slot/>
             
          </v-col>
       
        </v-row>
      
      </v-container>
  
    </v-content>

  </v-app>
</template>

<script>

  import FundacionLogo from '@/assets/svg/fundacion-idiomas-fundazioa.svg'

  export default {
    name: "LoginLayout",
    components: {
      FundacionLogo
    }  
  }

</script>



